import axios from 'axios';

export const getTransactionsWithUnpaidReferrerFees = () => {
    return axios.get('/api/admin/transactions/referrers-unpaid-fees');
};

export const sendTransactionMetamask = (data) => {
    return axios.post('/api/admin/transactions/send-crypto-metamask', data);
};

export const getSenderReceiverCryptoAddress = (data) => {
    return axios.post('/api/admin/transactions/sender-receiver-crypto-address', data);
};
